// dependencies
import { Map, List } from "immutable";

// selectors
import { getUI } from "Selectors/ui";
import { getDeployments as getDeploymentsFromReducer, getDeploymentsInfo } from "Selectors/deployments";

export const getDeployments = (state) => {
	const deploymentInfo = getDeploymentsInfo(state);
	const deployments = getDeploymentsFromReducer(state);

	return deployments
		.filter((d) => d.get("deploymentSubdomain", "").slice(0, 9) !== "cypress--")
		.map((deployment) => {
			const subdomain = deployment.get("deploymentSubdomain", null);

			return Map({
				id: subdomain,
				label: subdomain,
				domain: subdomain,
				log: deployment.get("log", Map()),
				deploymentType: deployment.get("deploymentType", null),
				hash: deploymentInfo.getIn([subdomain, "gitHash"], ""),
				branch: deploymentInfo.getIn([subdomain, "gitBranch"], ""),
				healthy: deploymentInfo.getIn([subdomain, "healthy"], null),
				nextUpdateIsReady: deploymentInfo.getIn([subdomain, "nextUpdateIsReady"], null),
			});
		});
};

export const getBranches = (state) => {
	const ui = getUI(state);
	const branches = ui.get("branches", List());

	return branches
		.map((branch) => ({
			value: branch.get("name"),
			label: branch.get("name"),
			branchName: branch.get("name"),
			commitHash: branch.getIn(["commit", "sha"]),
		}))
		.toJS();
};

export const selectDeployment = (state, domain, notSetValue = Map()) => {
	const deployments = getDeployments(state);
	return deployments.find((deployment) => deployment.get("domain") === domain, null, notSetValue);
};
